import { HttpResponse } from '@angular/common/http';
import { InjectableApi } from '@shared/decorators';
import { ApiService } from '@shared/services';
import { ForceAny } from '@shared/types';
import { Observable } from 'rxjs';

@InjectableApi({
  baseSegment: 'ats/auth',
})
export class ProfileService extends ApiService {
  getProfile(): Observable<HttpResponse<ForceAny>> {
    return this.headersGetRequest('/profile');
  }
}
